/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  CHANGE_PASSWORD: {},
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.klefki.userList.setActive',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        START: { target: 'CHANGE_PASSWORD' },
      },
    },
    CHANGE_PASSWORD: {
      invoke: {
        id: 'changePassword',
        src: 'changePassword',
        onDone: {
          target: 'CHANGE_PASSWORD_SUCCESS',
          actions: ['successAction'],
        },
        onError: {
          target: 'CHANGE_PASSWORD_FAILED',
          actions: ['failureAction'],
        },
      },
    },
    CHANGE_PASSWORD_SUCCESS: {
      on: {
        START: { target: 'CHANGE_PASSWORD' },
      },
    },
    CHANGE_PASSWORD_FAILED: {
      on: {
        START: { target: 'CHANGE_PASSWORD' },
      },
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
